import type { PillarPosition, FourPillars } from '../types/pillars';
import type { SinsalEntry, TwelveSinsalName } from '../types/sinsal';
import { branchIndex } from '../core/sexagenary';
import { getSamhapGroup, TWELVE_SINSAL_TABLE } from './definitions';

const TWELVE_SINSAL_NAMES: readonly TwelveSinsalName[] = [
  '겁살', '재살', '천살', '지살', '연살', '월살',
  '망신살', '장성살', '반안살', '역마살', '육해살', '화개살',
] as const;

/**
 * Find twelve sinsal based on a base pillar (typically year branch).
 */
export function findTwelveSinsal(
  fourPillars: FourPillars,
  basedOn: PillarPosition = 'year',
  noHour?: boolean,
): SinsalEntry[] {
  const entries: SinsalEntry[] = [];
  const baseBranchIdx = branchIndex(fourPillars[basedOn].branch);
  const group = getSamhapGroup(baseBranchIdx);
  const positions = TWELVE_SINSAL_TABLE[group];

  const pillarPositions: readonly PillarPosition[] = noHour ? ['year', 'month', 'day'] : ['year', 'month', 'day', 'hour'];

  for (const pos of pillarPositions) {
    const pillarBranchIdx = branchIndex(fourPillars[pos].branch);

    for (let i = 0; i < 12; i++) {
      if (positions[i] === pillarBranchIdx) {
        entries.push({
          name: TWELVE_SINSAL_NAMES[i],
          pillar: pos,
          basedOn,
        });
      }
    }
  }

  return entries;
}
